import { render } from "./BankIdLogin.vue?vue&type=template&id=c915e0d6&scoped=true&ts=true"
import script from "./BankIdLogin.vue?vue&type=script&lang=ts"
export * from "./BankIdLogin.vue?vue&type=script&lang=ts"

import "./BankIdLogin.vue?vue&type=style&index=0&id=c915e0d6&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/my-pages-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c915e0d6"]])

export default __exports__